import { createAsyncThunk } from "@reduxjs/toolkit";

import expertScheduleService from "services/expertSchedule";
import { setSelectedSlot } from "redux/reducers/expertScheduleSlice";
import { triggerAlert } from "redux/reducers/appSlice";
import {
  translateAPIMessage,
  translateFrontEndAlerts,
} from "../../utils/translation";
import expertProfileService from "services/expertProfile";

export const getExpertSchedules = createAsyncThunk(
  "get/expertSchedules",
  async (id: any, { rejectWithValue, dispatch }) => {
    try {
      const expertProfile = await expertProfileService.expertProfileGet();
      const response = await expertScheduleService.fetchExpertSchedules(
        id ? id : expertProfile?.data?.data.id
      );
      return response.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(
              error?.response?.data?.errors?.message as number
            ) || translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const createSchedules = createAsyncThunk(
  "create/expertSchedules",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertScheduleService.createSchedules(data);
      dispatch(getExpertSchedules(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(15001),
        })
      );
      return response.data?.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(error?.response?.data?.message as number) ||
            translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getSchedulesTemplate = createAsyncThunk(
  "get/expertSchedules/template",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertScheduleService.getScheduleTemplate(data);
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(15002),
        })
      );
      return (
        (response.data && response.data?.length > 0 && response.data[0]) || []
      );
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const addSchedule = createAsyncThunk(
  "schedule/add",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertScheduleService.addScheduleTimeSlot(data);
      dispatch(setSelectedSlot(data));
      dispatch(getExpertSchedules(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateFrontEndAlerts(15003),
        })
      );
      return response.data?.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(
              error?.response?.data?.errors?.message as number
              ||error?.response?.data?.message as number
            ) || translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const removeSchedule = createAsyncThunk(
  "schedule/add",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertScheduleService.removeScheduleTimeSlot(data);
      dispatch(getExpertSchedules(null));
      dispatch(
        triggerAlert({
          type: "success",
          children: translateAPIMessage(15004),
        })
      );
      return response.data?.data;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children:
            translateAPIMessage(
              error?.response?.data?.errors?.message as number
              ||error?.response?.data?.message as number
            ) || translateFrontEndAlerts(11001),
        })
      );
      return rejectWithValue(error);
    }
  }
);
